import React, { FC, useEffect, useState } from "react";
import { Badge, Card, Collapse } from "react-bootstrap";
import { MutatorEnums, MutatorProperty } from "../../../models/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { EnumDropdown } from "../../dropdowns/mutator/EnumDropdown";
import styles from "./CustomTypeCard.module.scss";
import cx from "classnames";

interface Props {
    property: MutatorProperty | any;
    enums: MutatorEnums;
    showMetaGlobal: boolean;
    getVariantByType: (type: string) => string;
    onChange: (name: string, value: string) => void;
}

const CustomTypeEnumCardImplementation: FC<Props> = ({
    property,
    enums,
    showMetaGlobal,
    getVariantByType,
    onChange
}) => {
    const [showMeta, updateShowMeta] = useState(showMetaGlobal);

    useEffect(() => {
        updateShowMeta(showMetaGlobal);
    }, [showMetaGlobal]);

    return (
        <Card
            className="m-2 inner-card text-inverse"
            key={property.name}
            id={property.name}
        >
            <Card.Header
                className={`d-flex align-items-center ${styles.cardHeader}`}
            >
                <span className={styles.headerText}>{property.name}</span>
                <Badge className="mx-2" bg={getVariantByType(property.type)}>
                    {property.type}
                </Badge>
                {property.meta ? (
                    <div
                        className="ms-auto float-end mouseHover"
                        onClick={() => updateShowMeta(!showMeta)}
                        title="Help and additional info"
                    >
                        <FontAwesomeIcon
                            icon={faCircleInfo}
                            className={cx("ms-2", {
                                "text-inverse-25": !showMeta,
                                "text-inverse-50": showMeta
                            })}
                        />
                    </div>
                ) : null}
            </Card.Header>
            <div>
                <Card.Body className={`${styles.cardBody} ms-1`}>
                    <EnumDropdown
                        isOptional={false}
                        property={property}
                        enums={enums}
                        getVariantByType={getVariantByType}
                        onChange={element => {
                            onChange(property.name, element);
                        }}
                    />
                </Card.Body>
            </div>
            {property.meta ? (
                <Collapse in={showMeta}>
                    <div>
                        <Card.Footer className={styles.footerInfo}>
                            {property.meta.description ? (
                                <div className="bread-text text-inverse-50">
                                    {property.meta.description}
                                </div>
                            ) : (
                                <span className="bread-text text-inverse-50">
                                    No description provided.
                                </span>
                            )}
                        </Card.Footer>
                    </div>
                </Collapse>
            ) : null}
        </Card>
    );
};

export const CustomTypeEnumCard = React.memo(CustomTypeEnumCardImplementation);
